import script from "./SupplierForecastCreationStatusIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupplierForecastCreationStatusIcon.vue?vue&type=script&lang=ts&setup=true"

import "./SupplierForecastCreationStatusIcon.vue?vue&type=style&index=0&id=710aa275&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-710aa275"]])

export default __exports__